import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HotelLinksLanding from "pages/OTAFront/HotelLinksLanding/index";
import HotelLanding from "pages/OTAFront/HotelLanding/index";
import Contact from "pages/OTAFront/Contact/index";
import NotFound from "pages/NotFound";

const ProjectRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HotelLinksLanding />} />
        <Route path="/hotel" element={<HotelLanding />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default ProjectRoutes;
